module.exports = __webpack_public_path__ + "img/arrow-answer-valid.263670c0.svg";